module.exports = __webpack_public_path__ + "static/media/labeouf-intro-2.74509a3d.wav";